import React, { useEffect, useMemo, useRef, useState } from "react";
import styles from "./Header.module.scss";

// İkonlar
import { ReactComponent as CloseIcon } from "../../assets/images/header/icons/close.svg";
import logo from "../../assets/images/site-logo/logo.svg";
// Navigasiya və Komponentlər
import { Link, useLocation, useNavigate, useSearchParams } from "react-router-dom";
import UserInfoDropdown from "../../components/user-info-dropdown/UserInfoDropdown";
import SearchDropDown from "../../components/search-dropdown/SearchDropDown";
import ImageSearch from "../../components/image-search/ImageSearch";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import BasketDrawer from "../../components/ui/basket-drawer/BasketDrawer";
import { setIsBasketOpen } from "../../redux/Slices/BasketSlice";
import { fetchUserData, setIsUser } from "../../redux/Slices/userSlice";
import HeaderDropdownProducts from "../../components/header/header-dropdown/HeaderDropdownProducts";
import HeaderDropDownMobile from "../../components/header/header-dropdown-mobile/HeaderDropDownMobile";
import HeaderProductCategories from "./headerServices/HeaderServices";
import { getTranslations } from "../../redux/Slices/dictionarySlice";
import { useAppDispatch } from "../../hooks/hook";
import { useHeaderCategories } from "../../hooks/useHomeQueries";
import { ApiCategory, ApiSubCategory, LanguageDataType } from "./types/types";
import { setLanguage } from "../../redux/Slices/languageSlice";
import { Swiper, SwiperSlide } from "swiper/react";
import type { SwiperClass } from "swiper/react";
import { FreeMode, Mousewheel } from "swiper/modules";
import "swiper/css";
import "swiper/css/free-mode";

// Yeni İkonlar
import { FiSearch, FiChevronRight, FiChevronLeft, FiCamera, FiChevronDown, FiCheck } from "react-icons/fi";
import { BiCategory } from "react-icons/bi";
import { HiOutlineHeart, HiOutlineShoppingCart, HiOutlineUser } from "react-icons/hi";
import { ChannelType, setChannel } from "../../redux/Slices/channelSlice";
import {
  startImageSearch,
  setImageSearchResults,
  setImageSearchError,
} from "../../redux/Slices/imageSearchSlice";

export type { ChannelType };

// Helper to find category by slug or id
const findCategory = (
  catList: ApiCategory[],
  identifier: string | number
): ApiCategory | null => {
  if (!catList || catList.length === 0 || !identifier) return null;
  const searchVal = String(identifier).trim().toLowerCase();
  for (const cat of catList) {
    if (
      String(cat.id).toLowerCase() === searchVal ||
      (cat.slug && String(cat.slug).trim().toLowerCase() === searchVal)
    ) {
      return cat;
    }
    if (cat.children && Array.isArray(cat.children)) {
      const found = findCategory(cat.children as ApiCategory[], identifier);
      if (found) return found;
    }
  }
  return null;
};

const Header: React.FC = () => {
  const theme = useSelector((state: RootState) => state.theme.mode);

  // İkonları dəyişən kimi təyin edirik
  const SearchIcon = FiSearch as any;
  const CameraIcon = FiCamera as any;
  const User = HiOutlineUser as any;
  const HeartIcon = HiOutlineHeart as any;
  const Basket = HiOutlineShoppingCart as any;
  const BiCategoryIcon = BiCategory as any;
  const ChevronRightIcon = FiChevronRight as any;
  const ChevronLeftIcon = FiChevronLeft as any;
  const ChevronDownIcon = FiChevronDown as any;
  const CheckIcon = FiCheck as any;

  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const dispatch = useDispatch();
  const dispatch_ = useAppDispatch();
  const isReduxUser = useSelector((state: RootState) => state.user.isUser);
  const token = isReduxUser ? localStorage.getItem("token") : null;

  const isHomePage = location.pathname === "/";
  const selectedCategoryParam = searchParams.get("category") || searchParams.get("category_id");

  // State-lər
  const [activeCategory, setActiveCategory] = useState<ApiCategory[] | null>(
    null,
  );
  const [hoveredCategory, setHoveredCategory] = useState<string | null>(null);
  const [activeItems, setActiveItems] = useState<ApiSubCategory[] | null>(null);
  const [isUserInfoDropdown, setIsUserInfoDropdown] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [path, setPath] = useState<string>("");
  const [mobileNavbar, setMobileNavbar] = useState(false);
  const isBasketOpen = useSelector(
    (state: RootState) => state.basket.isBasketOpen
  );
  const handleSetIsBasketOpen: React.Dispatch<React.SetStateAction<boolean>> = (
    value
  ) => {
    const nextVal = typeof value === "function" ? value(isBasketOpen) : value;
    dispatch(setIsBasketOpen(nextVal));
  };
  const [categories, setCategories] = useState<ApiCategory[]>([]);
  const [services] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [searchData, setSearchData] = useState<any[]>([]);
  const [isFavoritesOpen, setIsFavoritesOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [mobileSearchOpen, setMobileSearchOpen] = useState(false);
  const [isSearchDropdownOpen, setIsSearchDropdownOpen] = useState(false);

  // Channel Search State
  const selectedChannel = useSelector(
    (state: RootState) => state.channel.selectedChannel
  );
  const [isChannelDropdownOpen, setIsChannelDropdownOpen] = useState<boolean>(false);
  const [isMobileChannelDropdownOpen, setIsMobileChannelDropdownOpen] = useState<boolean>(false);

  // Image Search State
  const [isImageSearchOpen, setIsImageSearchOpen] = useState<boolean>(false);

  // Sync search keyword with URL param
  const urlSearchParam = searchParams.get("search") || searchParams.get("keyword") || "";
  useEffect(() => {
    if (urlSearchParam) {
      setSearchValue(urlSearchParam);
    }
  }, [urlSearchParam]);

  // Refs
  const userInfoDropdownRef = useRef<HTMLDivElement>(null);
  const searchDropdownRef = useRef<HTMLDivElement>(null);
  const channelDropdownRef = useRef<HTMLDivElement>(null);
  const mobileChannelDropdownRef = useRef<HTMLDivElement>(null);
  const navbarRef = useRef<HTMLDivElement>(null);
  const productsDropdownRef = useRef<HTMLDivElement>(null);
  const mobileSearchInputRef = useRef<HTMLInputElement>(null);
  const catalogWrapperRef = useRef<HTMLDivElement>(null);
  const searchDebounceTimerRef = useRef<NodeJS.Timeout | null>(null);

  const handleToggleImageSearch = () => {
    setIsImageSearchOpen((prev) => !prev);
  };

  const handleCloseImageSearch = () => {
    setIsImageSearchOpen(false);
  };

  const handleImageSearchResults = (
    products: any[],
    file: File,
    previewUrl?: string,
    meta?: {
      pagination?: any;
      picRegionInfo?: any;
      requestId?: string;
    }
  ) => {
    setLoading(false);
    setIsImageSearchOpen(true);
    setIsSearchDropdownOpen(false);
    dispatch(
      setImageSearchResults({
        results: products,
        fileName: file?.name,
        previewUrl,
        pagination: meta?.pagination,
        picRegionInfo: meta?.picRegionInfo,
        requestId: meta?.requestId,
      })
    );
    navigate("/products?search_type=image");
  };

  const handleImageSearchStart = (file?: File, previewUrl?: string) => {
    setLoading(true);
    setIsSearchDropdownOpen(false);
    setIsImageSearchOpen(true);
    dispatch(
      startImageSearch({
        previewUrl,
        fileName: file?.name,
      })
    );
    navigate("/products?search_type=image");
  };

  const handleImageSearchError = (error: any) => {
    setLoading(false);
    console.error("Image search error:", error);
    dispatch(setImageSearchError(translations?.no_products || "Məhsul tapılmadı"));
    navigate("/products?search_type=image");
  };

  // Redux Data
  const totalQuantity = useSelector(
    (state: RootState) => state.basket.totalQuantity,
  );
  const favoritesCount = useSelector(
    (state: RootState) => state.favorites.favoritesCount,
  );
  const user = useSelector((state: RootState) => state.user.userData);
  const translations = useSelector(
    (state: RootState) => state.translations.data,
  );
  const selectedLanguage = useSelector(
    (state: RootState) => state.language.selectedLanguage,
  );

  const selectedCategory = useMemo(() => {
    if (!selectedCategoryParam) return null;
    return findCategory(categories, selectedCategoryParam) || null;
  }, [categories, selectedCategoryParam]);

  const activeCategoryId = selectedCategory?.id || null;

  // Sync ?category_id=1137 to /products/:slug
  useEffect(() => {
    if (!isHomePage || !categories.length) return;
    const catIdParam = searchParams.get("category_id");
    if (!catIdParam) return;
    const matched = findCategory(categories, catIdParam);
    const targetSlug = matched?.slug || matched?.id;
    if (targetSlug) {
      navigate(`/products/${targetSlug}`);
    }
  }, [isHomePage, categories, searchParams, navigate]);

  const handleCategorySelect = (e: React.MouseEvent<HTMLButtonElement>, cat: ApiCategory): void => {
    e.preventDefault();
    const slugOrId = cat.slug || String(cat.id);
    navigate(`/products/${slugOrId}`);
  };

  const handleCategoryKeyDown = (
    e: React.KeyboardEvent<HTMLButtonElement>,
    cat: ApiCategory
  ): void => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      handleCategorySelect(e as unknown as React.MouseEvent<HTMLButtonElement>, cat);
    }
  };

  const categoriesSwiperRef = useRef<SwiperClass | null>(null);

  const handleCategoriesPrev = (): void => {
    if (!categoriesSwiperRef.current) return;
    categoriesSwiperRef.current.slidePrev();
  };

  const handleCategoriesNext = (): void => {
    if (!categoriesSwiperRef.current) return;
    categoriesSwiperRef.current.slideNext();
  };

  useEffect(() => {
    if (token) {
      dispatch_(fetchUserData());
    }
  }, [dispatch_, selectedLanguage, token]);

  useEffect(() => {
    if (selectedLanguage?.code) {
      dispatch_(getTranslations(selectedLanguage.code));
    }
  }, [dispatch_, selectedLanguage?.code]);

  const { data: headerCategoriesData } = useHeaderCategories(selectedLanguage?.code || "az");

  useEffect(() => {
    if (headerCategoriesData) {
      setCategories(Array.isArray(headerCategoriesData) ? (headerCategoriesData as ApiCategory[]) : []);
    }
  }, [headerCategoriesData]);

  useEffect(() => {
    const fetchLanguages = async () => {
      try {
        const response = await HeaderProductCategories.getLanguegs();
        const languages = response?.data?.data || response?.data || [];
        const azeLang = languages.find(
          (item: LanguageDataType) =>
            item.code?.toUpperCase() === "AZ" ||
            item.code?.toLowerCase() === "az" ||
            item.name?.toLowerCase().includes("azerbaijan")
        ) || languages[0];
        if (azeLang && selectedLanguage?.code?.toUpperCase() !== azeLang.code?.toUpperCase()) {
          dispatch(setLanguage(azeLang));
        }
      } catch (error) {
        console.error("Dillər alınmadı:", error);
      }
    };
    fetchLanguages();
  }, [dispatch, selectedLanguage?.code]);

  // Click Outside logic
  useEffect(() => {
    const handleClickOutsideSearch = (event: MouseEvent) => {
      const target = event.target as HTMLElement;
      if (
        searchDropdownRef.current &&
        !searchDropdownRef.current.contains(target) &&
        !mobileSearchInputRef.current?.contains(target) &&
        !target.closest(`.${styles.header_search_wrapper}`) &&
        !target.closest(`.${styles.mobile_search_bar}`) &&
        !target.closest('[aria-label="Şəkillə axtarış"]')
      ) {
        setIsSearchDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutsideSearch);
    return () => {
      document.removeEventListener("mousedown", handleClickOutsideSearch);
    };
  }, []);

  useEffect(() => {
    // const fetchData = async () => {
    //   try {
    //     const data = await HeaderProductCategories.AllHeaderServices();
    //     setServices(data.data.data);
    //   } catch (error) { }
    // };
    // fetchData();
  }, [selectedLanguage]);

  useEffect(() => {
    const handleClickOutside = (event: any) => {
      // Do not close dropdowns if clicking inside any modal, portal dialog, or overlay
      if (
        event.target?.closest?.('[role="dialog"]') ||
        event.target?.closest?.('[aria-modal="true"]')
      ) {
        return;
      }

      if (
        userInfoDropdownRef.current &&
        !userInfoDropdownRef.current.contains(event.target)
      ) {
        setIsUserInfoDropdown(false);
      }
      if (
        productsDropdownRef.current &&
        !productsDropdownRef.current.contains(event.target) &&
        !event.target.closest(`.${styles.nav_list}`)?.contains(event.target) &&
        !event.target
          .closest(`.${styles.catalog_wrapper}`)
          ?.contains(event.target)
      ) {
        setActiveCategory(null);
        setHoveredCategory(null);
        setIsDropdownOpen(false);
        setPath("");
      }
      const favoritesPanel = document.querySelector(
        `.${styles.favorites_panel}`,
      );
      if (favoritesPanel && !favoritesPanel.contains(event.target)) {
        setIsFavoritesOpen(false);
      }
      if (
        catalogWrapperRef.current &&
        !catalogWrapperRef.current.contains(event.target)
      ) {
        setIsDropdownOpen(false);
        setActiveCategory(null);
        setHoveredCategory(null);
        setPath("");
      }
      if (
        channelDropdownRef.current &&
        !channelDropdownRef.current.contains(event.target as Node)
      ) {
        setIsChannelDropdownOpen(false);
      }
      if (
        mobileChannelDropdownRef.current &&
        !mobileChannelDropdownRef.current.contains(event.target as Node)
      ) {
        setIsMobileChannelDropdownOpen(false);
      }
      if (
        navbarRef.current &&
        !navbarRef.current.contains(event.target as Node)
      ) {
        setMobileNavbar((isOpen) => {
          if (isOpen) {
            setTimeout(() => {
              setMobileSearchOpen(false);
              setIsSearchDropdownOpen(false);
            }, 300);
            return false;
          }
          return isOpen;
        });
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("touchstart", handleClickOutside, { passive: true });
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("touchstart", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const getToken = () => {
      const token = localStorage.getItem("token");
      if (token) {
        dispatch(setIsUser(true));
      } else {
        dispatch(setIsUser(false));
      }
    };
    getToken();
  }, [dispatch]);

  useEffect(() => {
    if (!mobileNavbar) {
      setPath("");
      document.body.classList.remove("catalog-open");
      return;
    }
    const originalOverflow = document.body.style.overflow;
    const originalTouchAction = document.body.style.touchAction;
    document.body.style.overflow = "hidden";
    document.body.style.touchAction = "pan-y";
    document.body.classList.add("catalog-open");
    return () => {
      document.body.style.overflow = originalOverflow;
      document.body.style.touchAction = originalTouchAction;
      document.body.classList.remove("catalog-open");
    };
  }, [mobileNavbar]);

  const handleCategoryHover = (type: "products" | "services"): void => {
    if (window.innerWidth <= 1024) return;
    if (path === type && isDropdownOpen) return;

    setPath(type);
    if (type === "products") {
      const transformedCategories: ApiCategory[] = categories.map(
        (category) => ({
          ...category,
          children: category.children?.map((subCategory) => ({
            ...subCategory,
            children: subCategory.children?.map((item) => ({
              id: item.id,
              name: item.name,
              parent_id: item.parent_id,
            })),
          })),
        }),
      );
      setActiveCategory(transformedCategories);
    } else if (type === "services") {
      setActiveCategory(services);
    }
    setIsDropdownOpen(true);
  };

  const handleMouseLeave = () => {
    setActiveCategory(null);
    setHoveredCategory(null);
    setIsDropdownOpen(false);
    setIsUserInfoDropdown(false);
    setPath("");
  };

  useEffect(() => {
    setIsDropdownOpen(false);
    setIsUserInfoDropdown(false);
    if (!isImageSearchOpen) {
      setMobileSearchOpen(false);
    }
    setIsSearchDropdownOpen(false);
    setSearchValue("");
    setSearchData([]);
  }, [location, isImageSearchOpen]);

  // !!! DİQQƏT: Avtomatik yönləndirməni sildim ki, burger menyu açılanda bütün linklər görünsün !!!
  // useEffect(() => {
  //   if (mobileNavbar) {
  //     const firstCategory = navigation.find((nav) => nav.dropdown);
  //     if (firstCategory) {
  //       setPath("products");
  //     }
  //   }
  // }, [mobileNavbar]);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 1024) {
        setMobileNavbar(false);
        setMobileSearchOpen(false);
        setIsSearchDropdownOpen(false);
      }
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const closeMobileNavbar = () => {
    setMobileNavbar(false);
    setTimeout(() => {
      setMobileSearchOpen(false);
      setIsSearchDropdownOpen(false);
    }, 300);
  };

  const handleSearchChange = (value: string): void => {
    setSearchValue(value);
    if (isSearchDropdownOpen) {
      setIsSearchDropdownOpen(false);
    }
  };

  const handleImmediateSearch = (): void => {
    const trimmedKeyword = searchValue.trim();
    if (!trimmedKeyword) return;

    if (searchDebounceTimerRef.current) {
      clearTimeout(searchDebounceTimerRef.current);
    }

    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }

    setIsSearchDropdownOpen(false);
    setMobileSearchOpen(false);
    setMobileNavbar(false);
    navigate(`/products?search=${encodeURIComponent(trimmedKeyword)}`);
  };

  const handleChannelSelect = (channel: ChannelType): void => {
    dispatch(setChannel(channel));
    setIsChannelDropdownOpen(false);
    setIsMobileChannelDropdownOpen(false);
    setIsSearchDropdownOpen(false);
  };

  const handleSearchResultClose = () => {
    setSearchData([]);
    setSearchValue("");
    setIsSearchDropdownOpen(false);
    setMobileSearchOpen(false);
  };

  // Remove top-level skeleton to prevent CLS
  // if (translations?.Loading) {
  //   return <Skeleton count={5} />;
  // }

  return (
    <header id={styles.header}>
      <div
        style={{ backgroundColor: theme === "dark" ? "rgb(38, 38, 38)" : " " }}
        className={styles.header_bottom}
      >
        <div className="container">
          <div className={styles.header_bottom_content}>
            {/* STANDART HEADER CONTENT (Logo, Kataloq, Desktop Axtarış, İkonlar) */}
            <div className={styles.standard_content}>
              {/* SOL TƏRƏF */}
              <div className={styles.header_bottom_start}>
                <Link to="/" className={styles.logo} aria-label="1412" tabIndex={0}>
                  <img
                    src={logo}
                    alt="1412 logo"
                    width="65"
                    height="44"
                  />
                </Link>
                <Link to="/" className={styles.mobile_logo} aria-label="1412" tabIndex={0}>
                  <img
                    src={logo}
                    alt="1412 logo"
                    width="56"
                    height="38"
                  />
                </Link>

                <div
                  className={styles.catalog_wrapper}
                  ref={catalogWrapperRef}
                  onMouseLeave={handleMouseLeave}
                  onMouseEnter={() => handleCategoryHover("products")}
                >
                  <button
                    className={styles.catalog_btn}
                    onClick={() => {
                      if (window.innerWidth <= 1024) {
                        setMobileNavbar((prev) => !prev);
                      }
                    }}
                    aria-label="Kataloq"
                    tabIndex={0}
                  >
                    <BiCategoryIcon size={24} color="#FFFFFF" />
                    <span>Kataloq</span>
                  </button>

                  {isDropdownOpen && activeCategory && !mobileNavbar && (
                    <div
                      ref={productsDropdownRef}
                      className={styles.mega_menu_wrapper}
                    >
                      <HeaderDropdownProducts
                        path={path}
                        onMouseEnter={() =>
                          setHoveredCategory(hoveredCategory)
                        }
                        onMouseLeave={handleMouseLeave}
                        activeCategory={activeCategory}
                        hoveredCategory={hoveredCategory}
                        activeItems={activeItems}
                        setHoveredCategory={setHoveredCategory}
                        setActiveItems={setActiveItems}
                        translations={translations}
                      />
                    </div>
                  )}
                </div>
              </div>

              <div className={styles.header_search_wrapper}>
                <div
                  className={`${styles.search_box} ${theme === "dark"
                      ? styles.search_box_dark
                      : styles.search_box_light
                    }`}
                >
                  <div className={styles.channel_select_wrapper} ref={channelDropdownRef}>
                    <button
                      type="button"
                      className={styles.channel_select_btn}
                      onClick={() => setIsChannelDropdownOpen((prev) => !prev)}
                      aria-label="Kanal seçin"
                      tabIndex={0}
                    >
                      <span className={styles.channel_text}>
                        {selectedChannel === "1688" ? "1688" : selectedChannel === "taobao" ? "Taobao" : "Weidian"}
                      </span>
                      <ChevronDownIcon
                        size={14}
                        className={`${styles.channel_chevron} ${isChannelDropdownOpen ? styles.channel_chevron_open : ""}`}
                      />
                    </button>
                    {isChannelDropdownOpen && (
                      <div className={styles.channel_dropdown_menu}>
                        {(["1688", "taobao" /*, "weidian"*/] as ChannelType[]).map((ch) => (
                          <button
                            key={ch}
                            type="button"
                            className={`${styles.channel_dropdown_item} ${selectedChannel === ch ? styles.channel_dropdown_item_active : ""}`}
                            onClick={() => handleChannelSelect(ch)}
                            tabIndex={0}
                          >
                            <span>{ch === "1688" ? "1688" : ch === "taobao" ? "Taobao" : "Weidian"}</span>
                            {selectedChannel === ch && <CheckIcon size={14} className={styles.channel_check_icon} />}
                          </button>
                        ))}
                      </div>
                    )}
                  </div>

                  <div className={styles.channel_divider} />

                  <button
                    type="button"
                    className={styles.search_icon_btn}
                    onClick={handleImmediateSearch}
                    aria-label="Axtar"
                    title="Axtar"
                    tabIndex={0}
                  >
                    <SearchIcon
                      size={20}
                      color={theme === "dark" ? "#FFFFFF" : "#687066"}
                      className={styles.search_left_icon}
                    />
                  </button>
                  <input
                    type="text"
                    className={styles.search_input}
                    placeholder="Məhsul və ya kateqoriya axtarın"
                    value={searchValue}
                    onChange={(e) => handleSearchChange(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        handleImmediateSearch();
                      }
                    }}
                  />
                  <button
                    type="button"
                    className={`${styles.camera_search_btn} ${isImageSearchOpen ? styles.camera_active : ""}`}
                    onClick={handleToggleImageSearch}
                    aria-label="Şəkillə axtarış"
                    title="Şəkillə axtarış"
                    tabIndex={0}
                  >
                    <CameraIcon size={20} color={theme === "dark" ? "#FFFFFF" : "#344733"} />
                  </button>
                  <button
                    type="button"
                    className={styles.search_action_btn}
                    aria-label="Axtar"
                    tabIndex={0}
                    onClick={handleImmediateSearch}
                  >
                    Axtar
                  </button>
                </div>

                {/* DESKTOP IMAGE SEARCH POPOVER */}
                {isImageSearchOpen && !mobileSearchOpen && (
                  <ImageSearch
                    isOpen={isImageSearchOpen}
                    channel={selectedChannel}
                    onClose={handleCloseImageSearch}
                    onSearchResults={handleImageSearchResults}
                    onSearchStart={handleImageSearchStart}
                    onSearchError={handleImageSearchError}
                  />
                )}
              </div>

              {/* SAĞ TƏRƏF (İkonlar) */}
              <div className={styles.header_bottom_end}>
                <div className={styles.functional_icons}>
                  {/* Favorilər */}
                  <div className={styles.icon_box}>
                    <Link
                      to="/favourites"
                      onClick={(e) => {
                        e.stopPropagation();
                        setIsFavoritesOpen(!isFavoritesOpen);
                      }}
                      className={styles.icon_link}
                      aria-label={translations?.favorites || "Sevimlilər"}
                      tabIndex={0}
                    >
                      <span className={styles.icon_icon_wrapper}>
                        <HeartIcon
                          size={24}
                          color={theme === "dark" ? "#FFFFFF" : "#20251F"}
                          style={{ transition: "color 0.3s ease" }}
                        />
                        <span className={styles.count_wrapper}>
                          <span className={styles.icon_text}>
                            {token ? favoritesCount : 0}
                          </span>
                        </span>
                      </span>
                      <span className={styles.icon_label}>{translations?.favorites || "Sevimlilər"}</span>
                    </Link>
                  </div>

                  {/* Səbət */}
                  <div
                    className={styles.icon_box}
                    onClick={() => dispatch(setIsBasketOpen(true))}
                  >
                    <Link
                      to="/"
                      className={styles.icon_link}
                      aria-label={translations?.basket || "Səbət"}
                      onClick={(e) => e.preventDefault()}
                      tabIndex={0}
                    >
                      <span className={styles.icon_icon_wrapper}>
                        <Basket
                          size={24}
                          color={theme === "dark" ? "#FFFFFF" : "#20251F"}
                          style={{ transition: "color 0.3s ease" }}
                        />
                        <span className={styles.count_wrapper}>
                          <span className={styles.icon_text}>{totalQuantity}</span>
                        </span>
                      </span>
                      <span className={styles.icon_label}>{translations?.basket || "Səbət"}</span>
                    </Link>
                  </div>

                  {/* User Login / Profil */}
                  {token ? (
                    <div
                      className={styles.icon_box}
                      ref={userInfoDropdownRef}
                    >
                      <button
                        onClick={() => setIsUserInfoDropdown((prev) => !prev)}
                        className={styles.icon_link}
                        aria-label="User Account"
                        tabIndex={0}
                      >
                        <span className={styles.icon_icon_wrapper}>
                          <User
                            size={24}
                            color={theme === "dark" ? "#FFFFFF" : "#20251F"}
                          />
                        </span>
                        <span className={styles.icon_label}>Profil</span>
                      </button>

                      {isUserInfoDropdown && (
                        <UserInfoDropdown
                          onMouseEnter={() => setHoveredCategory(hoveredCategory)}
                          onMouseLeave={handleMouseLeave}
                          user={user}
                          translations={translations}
                        />
                      )}
                    </div>
                  ) : (
                    <div className={styles.icon_box}>
                      <Link
                        to="/login"
                        className={styles.icon_link}
                        aria-label={translations?.login || "Daxil ol"}
                        tabIndex={0}
                      >
                        <span className={styles.icon_icon_wrapper}>
                          <User
                            size={24}
                            color={theme === "dark" ? "#FFFFFF" : "#20251F"}
                          />
                        </span>
                        <span className={styles.icon_label}>{translations?.login || "Daxil ol"}</span>
                      </Link>
                    </div>
                  )}
                </div>
                
                {/* DİL SEÇİMİ */}
               
              </div>
            </div>
            {/* --- Standart Header End --- */}

            {/* MOBİL VƏ TABLET AXTARIŞ SƏTRİ (< 1025px) */}
            <div className={styles.header_mobile_search_row}>
              <div
                className={`${styles.search_box} ${
                  theme === "dark"
                    ? styles.search_box_dark
                    : styles.search_box_light
                }`}
              >
                <div
                  className={styles.channel_select_wrapper}
                  ref={mobileChannelDropdownRef}
                >
                  <button
                    type="button"
                    className={styles.channel_select_btn}
                    onClick={() => setIsMobileChannelDropdownOpen((prev) => !prev)}
                    aria-label="Kanal seçin"
                    tabIndex={0}
                  >
                    <span className={styles.channel_text}>
                      {selectedChannel === "1688"
                        ? "1688"
                        : selectedChannel === "taobao"
                        ? "Taobao"
                        : "Weidian"}
                    </span>
                    <ChevronDownIcon
                      size={14}
                      className={`${styles.channel_chevron} ${
                        isMobileChannelDropdownOpen
                          ? styles.channel_chevron_open
                          : ""
                      }`}
                    />
                  </button>
                  {isMobileChannelDropdownOpen && (
                    <div className={styles.channel_dropdown_menu}>
                      {(["1688", "taobao"] as ChannelType[]).map((ch) => (
                        <button
                          key={ch}
                          type="button"
                          className={`${styles.channel_dropdown_item} ${
                            selectedChannel === ch
                              ? styles.channel_dropdown_item_active
                              : ""
                          }`}
                          onClick={() => handleChannelSelect(ch)}
                          tabIndex={0}
                        >
                          <span>
                            {ch === "1688"
                              ? "1688"
                              : ch === "taobao"
                              ? "Taobao"
                              : "Weidian"}
                          </span>
                          {selectedChannel === ch && (
                            <CheckIcon
                              size={14}
                              className={styles.channel_check_icon}
                            />
                          )}
                        </button>
                      ))}
                    </div>
                  )}
                </div>

                <div className={styles.channel_divider} />

                <button
                  type="button"
                  className={styles.search_icon_btn}
                  onClick={handleImmediateSearch}
                  aria-label="Axtar"
                  title="Axtar"
                  tabIndex={0}
                >
                  <SearchIcon
                    size={20}
                    color={theme === "dark" ? "#FFFFFF" : "#687066"}
                    className={styles.search_left_icon}
                  />
                </button>
                <input
                  type="text"
                  className={styles.search_input}
                  placeholder={
                    translations?.search_placeholder ||
                    "Məhsul və ya kateqoriya axtarın"
                  }
                  value={searchValue}
                  onChange={(e) => handleSearchChange(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      handleImmediateSearch();
                    }
                  }}
                />
                <button
                  type="button"
                  className={`${styles.camera_search_btn} ${
                    isImageSearchOpen ? styles.camera_active : ""
                  }`}
                  onClick={handleToggleImageSearch}
                  aria-label="Şəkillə axtarış"
                  title="Şəkillə axtarış"
                  tabIndex={0}
                >
                  <CameraIcon
                    size={20}
                    color={theme === "dark" ? "#FFFFFF" : "#344733"}
                  />
                </button>
                <button
                  type="button"
                  className={styles.search_action_btn}
                  aria-label="Axtar"
                  tabIndex={0}
                  onClick={handleImmediateSearch}
                >
                  Axtar
                </button>
              </div>

              {/* MOBİL / TABLET IMAGE SEARCH POPOVER */}
              {isImageSearchOpen && (
                <ImageSearch
                  isOpen={isImageSearchOpen}
                  channel={selectedChannel}
                  onClose={handleCloseImageSearch}
                  onSearchResults={handleImageSearchResults}
                  onSearchStart={handleImageSearchStart}
                  onSearchError={handleImageSearchError}
                />
              )}
            </div>

            {/* Mobil Navbar Overlay Backdrop */}
            {mobileNavbar && (
              <div
                className={styles.navbar_overlay}
                onClick={closeMobileNavbar}
                onTouchStart={closeMobileNavbar}
                aria-label="Kataloqu bağla"
              />
            )}

            {/* Mobil Navbar Drawer (Yenilənmiş Hissə) */}
            <div
              ref={navbarRef}
              className={`${styles.navbar} ${mobileNavbar ? styles.open : ""}`}
            >
              {mobileNavbar && (
                <div className={styles.mobile_header}>
                  <h3 className={styles.mobile_drawer_title}>
                    {translations?.catalog || "Kataloq"}
                  </h3>
                  <div
                    className={styles.x_icon}
                    onClick={closeMobileNavbar}
                    aria-label="Bağla"
                    tabIndex={0}
                  >
                    <CloseIcon />
                  </div>
                </div>
              )}

              {/* Mobil Kataloq Dropdown - Desktopdakı kimi birbaşa kateqoriyaları göstərir */}
              {mobileNavbar && (
                <HeaderDropDownMobile
                  path="products"
                  onClick={() => setHoveredCategory(hoveredCategory)}
                  activeCategory={categories}
                  isMobileDropdownOpen={mobileNavbar}
                  setMobileNavbar={setMobileNavbar}
                  translations={translations}
                />
              )}
            </div>
          </div>
        </div>
      </div>

      {/* --- CATEGORIES GREEN NAV HEADER --- */}
      {isHomePage && categories.length > 0 && (
        <div className={styles.nav_header}>
          <div className="container">
            <div className={styles.categories_nav_wrapper}>
              <button
                type="button"
                className={`${styles.category_nav_arrow} ${styles.category_nav_prev}`}
                onClick={handleCategoriesPrev}
                aria-label="Əvvəlki kateqoriyalar"
                tabIndex={0}
              >
                <ChevronLeftIcon size={16} />
              </button>

              <div className={styles.subbar_scroll_container}>
                <Swiper
                  modules={[FreeMode, Mousewheel]}
                  onSwiper={(swiper: SwiperClass) => {
                    categoriesSwiperRef.current = swiper;
                  }}
                  slidesPerView={"auto"}
                  spaceBetween={8}
                  freeMode={{
                    enabled: true,
                    momentum: true,
                  }}
                  mousewheel={{
                    forceToAxis: true,
                    releaseOnEdges: true,
                  }}
                  grabCursor={true}
                  allowTouchMove={true}
                  className={styles.categories_swiper}
                >
                  {categories.map((cat) => {
                    const isCatActive = isHomePage && activeCategoryId === cat.id;
                    return (
                      <SwiperSlide key={cat.id} className={styles.subbar_category_item}>
                        <button
                          type="button"
                          onClick={(e) => handleCategorySelect(e, cat)}
                          onKeyDown={(e) => handleCategoryKeyDown(e, cat)}
                          className={`${styles.subbar_category_link} ${isCatActive ? styles.subbar_category_active : ""}`}
                          title={cat.name}
                          aria-label={cat.name}
                          tabIndex={0}
                        >
                          {cat.name}
                        </button>
                      </SwiperSlide>
                    );
                  })}
                </Swiper>
              </div>

              <button
                type="button"
                className={`${styles.category_nav_arrow} ${styles.category_nav_next}`}
                onClick={handleCategoriesNext}
                aria-label="Növbəti kateqoriyalar"
                tabIndex={0}
              >
                <ChevronRightIcon size={16} />
              </button>
            </div>
          </div>
        </div>
      )}


      {/* Axtarış Nəticələri */}
      {isSearchDropdownOpen && (
        <div ref={searchDropdownRef}>
          <SearchDropDown
            onMouseEnter={() => setHoveredCategory(hoveredCategory)}
            onMouseLeave={handleMouseLeave}
            translations={translations}
            searchData={searchData}
            loading={loading}
            searchValue={searchValue}
            onItemClick={handleSearchResultClose}
          />
        </div>
      )}

      {isBasketOpen && (
        <BasketDrawer isOpen={isBasketOpen} setIsOpen={handleSetIsBasketOpen} />
      )}
    </header>
  );
};

export default Header;
